export const DEFAULT_MAX_RESULTS_COUNT = 5;

export interface ComboBoxOption {
  // Text for labelling the option in the dropdown
  displayText: string;
  // Unique identifier for the option, used to match click to an option
  key: string;
  // Secondary text rendered in lighter color right aligned on the option
  subText?: string;
  // When the option is selected, the onSelect is called with this specific value
  value: any;
}

export const SearchInputTestID = 'ComboBox.SearchInputTestID';
